import React from 'react';
import EventEmitter from '../../modules/event-emitter/EventEmitter';
import Listener from '../../../const/Listener';
import Header from './headerPortal/Header';
import HeaderCallcenter from './headerCallcenter/HeaderCallcenter';

class HeaderContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      userAD: null,
      nameUserAD: null,
      role: null
    };

    EventEmitter.createListener(Listener.REFRESH_TOKEN_CALLCENTER, this.toggleHeaderDisplay);
  }

  toggleHeaderDisplay = callcenterUserAD => {
    this.setState({
      userAD: callcenterUserAD[0],
      nameUserAD: callcenterUserAD[1],
      role: callcenterUserAD[2]
    });
  };

  renderHeader() {
    if (this.state.userAD && this.state.userAD !== '') {
      return <HeaderCallcenter userAD={this.state.userAD} nameUserAD={this.state.nameUserAD} role={this.state.role}/>
    } else {
      return <Header />;
    }
  }

  render() {
    return this.renderHeader();
  }
}

export default HeaderContainer;



// WEBPACK FOOTER //
// ./src/components/header/headerContainer/HeaderContainer.jsx